document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    function filterImages(color) {
      if (!color) return;
      color = color.trim().toLowerCase();

      document.querySelectorAll('.product__media-item').forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;

        var alt = (img.alt || '').trim().toLowerCase();

        // ✅ MAIN LOGIC
        if (alt === 'forall' || alt === color) {
          item.style.setProperty('display', '', 'important'); // show
        } else {
          item.style.setProperty('display', 'none', 'important'); // hide
        }
      });

      document.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;

        var alt = (img.alt || '').trim().toLowerCase();

        // ✅ SAME LOGIC
        if (alt === 'forall' || alt === color) {
          item.style.setProperty('display', '', 'important');
        } else {
          item.style.setProperty('display', 'none', 'important');
        }
      });
    }

    var productForm = document.querySelector('product-info');
    if (productForm) {
      productForm.addEventListener('change', function (e) {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') {
          setTimeout(function () {
            var active = document.querySelector('.product-form__input input:checked, .swatch-input__input:checked');
            if (active) filterImages(active.value);
          }, 100);
        }
      });
    }

    var defaultChecked = document.querySelector('.swatch-input__input:checked, input[type="radio"]:checked');
    if (defaultChecked) filterImages(defaultChecked.value);

  }, 1000);
});